import { lazy } from 'react'

const WeblinkConfig =  {
  path: '/:tipo/:url?',
  component: lazy(() => import('./Weblink')),
  layout: 'WebLinksLayout',
}
export default WeblinkConfig